import { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { Button, Typography } from 'antd';
import Tag from 'antd/es/tag';

import { Input } from '@/components/form/Input';
import { Toggle } from '@/components/form/Toggle';
import ArrowUpRight from '@/components/icons/ArrowUpRight';
import { Modrawer } from '@/components/Modrawer';

const Rvp = () => {
  const [openRvpModrawer, setOpenRvpModrawer] = useState(false);
  const form = useFormContext();
  const isRecoverySalesEnabled = form.watch('recoverySales');

  const handleRvpToggleClick = useCallback((checked: boolean) => {
    setOpenRvpModrawer(!checked);
  }, []);

  return (
    <>
      <div className='flex flex-col gap-4 py-4'>
        <div className='flex items-center justify-between'>
          <div className='flex flex-col gap-1'>
            <Typography.Text strong>Recuperação de vendas perdidas</Typography.Text>
            <span className='text-content-body text-xs'>
              Ajudamos você a recuperar vendas que não foram concluídas, sem custo adicional.
            </span>

            <Tag color='green' className='flex! w-fit items-center! gap-1'>
              <ArrowUpRight />
              Até 15,9% a mais de conversão
            </Tag>
          </div>

          <div>
            <Toggle id='toggle-recovery-sales' name='recoverySales' onClick={handleRvpToggleClick} />
          </div>
        </div>

        {isRecoverySalesEnabled && (
          <div>
            <Input
              id='recovery-sales-name'
              label='Nome que aparecerá nos emails'
              name='recoveryEmailSenderName'
              placeholder='Nome do remetente nos emails'
            />
          </div>
        )}
      </div>

      <Modrawer
        open={openRvpModrawer}
        onCancel={() => setOpenRvpModrawer(false)}
        footer={[
          <section key='modal-rvp-footer' className='flex justify-end gap-2'>
            <Button
              id='cancel-rvp-disable-button'
              key='cancel'
              className='text-primary! flex-1 md:flex-none'
              type='text'
              onClick={() => setOpenRvpModrawer(false)}
            >
              Desativar mesmo assim
            </Button>
            <Button
              id='confirm-rvp-disable-button'
              key='ok'
              className='flex-1 md:flex-none'
              type='primary'
              onClick={() => {
                setOpenRvpModrawer(false);
                form.setValue('recoverySales', true);
              }}
            >
              Manter ativa
            </Button>
          </section>
        ]}
        title='Deseja realmente desativar?'
      >
        <Tag color='green' className='mb-2! flex! w-fit items-center! gap-1'>
          <ArrowUpRight />
          Até 15,9% a mais de conversão
        </Tag>

        <p className='text-base'>
          A <b>Recuperação de Vendas Perdidas (RVP)</b> identifica compras não concluídas e envia mensagens automáticas
          para incentivar o cliente a finalizar a compra, aumentando suas chances de conversão.
        </p>

        <p className='text-base'>
          A ferramenta <b>não possui taxa de uso</b>, o que significa que você pode aproveitar todos os recursos de
          recuperação <b>sem custos adicionais.</b>
        </p>

        <small className='text-content-body text-sm!'>
          Se ainda tiver dúvidas sobre a RVP, consulte a documentação completa{' '}
          <a
            id='rvp-doc-link'
            className='underline!'
            target='_blank'
            href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807625289-como-funciona-a-recupera%C3%A7%C3%A3o-de-vendas-perdidas-rvp-'
            rel='noreferrer'
          >
            neste link
          </a>
          .
        </small>
      </Modrawer>
    </>
  );
};

export default Rvp;
